export default "__VITE_ASSET__pxJxDp2q__"